import React from "react";
import { useSelector, useDispatch } from "react-redux";
import withStyles from "@material-ui/styles/withStyles";
import { useTranslation } from "react-i18next";
import { Grid } from "@material-ui/core";
import CustomForm from "../../../../common/components/CustomForm";

import { styles } from "./BoxForm.styles";
import { formFields, formSchema } from "./BoxForm.schema";

import { selectError, addBox, updateBox, selectLoader } from "../../structureSlice";

function BoxForm({ classes, selectedProject, payload, onSubmit }) {
  const { t } = useTranslation();
  const error = useSelector(selectError);
  const loader = useSelector(selectLoader);
  const dispatch = useDispatch();

  const onSubmitHandler = async (values) => {
    console.log("values: %o", values);
    if (!values.id) {
      dispatch(addBox(selectedProject, values));
    }
    else {
      dispatch(updateBox(selectedProject, values));
    }
    onSubmit && onSubmit();
  };

  return (
    <Grid
      className={classes.root}
      container
      direction="row"
      justify="center"
      alignItems="center"
    >
      <div>
        <CustomForm
          payload={payload}
          schema={formSchema(t)}
          fields={() => formFields(t)}
          error={error}
          submitLabel={"Submit"}
          onSubmit={onSubmitHandler}
          submitting={Boolean(loader)}
        />
      </div>
    </Grid>
  );
}

export default withStyles(styles)(BoxForm);
